<div class="video-poster-card" [routerLink]="['watch/' + video.id]">
  <div class="filter"></div>
  <div class="background">
    <ng-container *ngIf="isVideoPreview">
      <video
        class="background-video"
        loop
        [muted]="'muted'"
        autoplay
        playsinline
        preload="auto"
        data-wf-ignore="true"
        [poster]="video.thumbnails.large">
        <source type="video/mp4" [src]="video.urls.hd" data-wf-ignore="true" />
      </video>
    </ng-container>
    <img
      class="background-image"
      [ngClass]="{ 'display-none': isVideoPreview }"
      [src]="video.thumbnails.medium"
      [alt]="video.name"
      onerror="this.style.display = 'none'" />
  </div>
  <div class="rank-info">
    {{ rank }}
  </div>
  <div class="video-info">
    <app-sport-country-avatars
      [sportName]="video.sport"
      [countryCode]="video.country_start.code"></app-sport-country-avatars>
  </div>
  <div class="title-info">
    {{ video.name }}
  </div>
  <div class="duration-info">
    <span class="icon icon-timer"></span>
    <span class="duration-value">{{
      video.duration / 60 | number: '1.0-0'
    }}</span>
    <span class="duration-unity">min</span>
  </div>
</div>
